import styled from 'styled-components';

const StyledCouponCodeBox = styled.div`
.marquee {
    height: 50px;
    overflow: hidden;
    position: relative;
  }
  
  .marquee p {
    position: absolute;
    width: 100%;
    min-width: max-content;
    height: 100%;
    margin: 0;
    line-height: 50px;
    text-align: center;
    -moz-transform: translateX(100%);
    -webkit-transform: translateX(100%);
    transform: translateX(100%);
    -moz-animation: scroll-left 2s linear infinite;
    -webkit-animation: scroll-left 2s linear infinite;
    animation: scroll-left 20s linear infinite;
  }
  
  @-moz-keyframes scroll-left {
    0% {
        -moz-transform: translateX(100%);
    }
    100% {
        -moz-transform: translateX(-100%);
    }
  }
  
  @-webkit-keyframes scroll-left {
    0% {
        -webkit-transform: translateX(100%);
    }
    100% {
        -webkit-transform: translateX(-100%);
    }
  }
  
  @keyframes scroll-left {
    0% {
        -moz-transform: translateX(100%);
        -webkit-transform: translateX(100%);
        transform: translateX(100%);
    }
    100% {
        -moz-transform: translateX(-100%);
        -webkit-transform: translateX(-100%);
        transform: translateX(-100%);
    }
  }
  
  .marquee .coupon-description{
    font-size: 18px;
    font-weight: bold;
    color: ${(props) => props.theme.corellBlue};
  }
  .marquee .coupon-code-title{
    font-size: 18px;
    font-weight: bold;
    color: ${(props) => props.theme.corellBlue};
    padding: 0 5px;
  }
  .marquee .coupon-code{
    font-size: 18px;
    font-weight: bold;
    color: ${(props) => props.theme.corellBlue};
    color: ${(props) => props.theme.corellBlue};
  }
`;

const StyledPropelCorporateGiftingCampaignHeader = styled.div`
.propel-corporate-gifting-carousel{
  margin-top: 0.2rem;
  margin-bottom: 2.5rem;
  .slick-dots{
    height: auto;
    bottom: -2rem;
    left: 0px;
    text-align: center;
    li{
      background: none;
      border:${({ theme }) => theme.lightGray} solid 2px;
      width:12px;
      height:12px;
      border-radius:50%;
      cursor:pointer;
      &.slick-active{
        background: none;
        border:none;
        button{
          background: ${({ theme }) => theme.primaryColor};
          border: 2px solid ${({ theme }) => theme.LandingBlack};
          width:12px;
          height:12px;
          border-radius: 50%;
          &:before{
            color: ${({ theme }) => theme.transparentColor};
          }
        }
      }
      button{
        background: none;
        height:10px;
        &:before{
          color: ${({ theme }) => theme.transparentColor};
        }
      }
    }
  }
}
`;

export {
  StyledCouponCodeBox,
  StyledPropelCorporateGiftingCampaignHeader,
};



// WEBPACK FOOTER //
// client/containers/GiftCard/StyledGiftCard.js